import RouteService from "@/services/RouteService";
import MainHeader from "@/components/MainHeader.vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
export default {
  name: "SharedCharges",
  uiView: "edit",
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  components: {
    MainHeader,
    LlSecondaryButton
  },
  data() {
    return {
      charges: undefined,
      ledes: undefined
    };
  },
  async mounted() {
    this.me = await this.userService.getMe();
    this.listCharges = await this.leanLawApi.listStandardCharges();
    this.ledes = this.me.company.settings.codes?.ledes;
    this.charges = this.listCharges.charges.sort((a, b) => {
      a.display = a.label || a.description;
      b.display = b.label || b.description;
      return a.display.localeCompare(b.display);
    });
  },
  methods: {
    updateCharge(charge) {
      this.routeService = new RouteService(this);
      this.routeService.go('.edit', charge);
    }
  }
};